import React, { useState } from 'react';
import categoryimage from "../assets/CategoryCard.png"
import { Typography } from '@mui/material';
import '../styles/components/CategoryCard.scss';
import Image from '../../Utils/getImage';

const CategoryCard = ({ title, image,onclick }) => {
    const [imgSrc, setImgSrc] = useState(image || categoryimage);

    return (
        <div className='CategoryCard' onClick={onclick}>
            <Image src={image} alt="Category Card" onError={() => setImgSrc(categoryimage)} />
            <Typography >{title}</Typography>
        </div>
    )
}

export default CategoryCard